<template>
  <div>
    <resultado-financeiro-table ref="resultadoFinanceiroTableRef"></resultado-financeiro-table>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { log } from '../../utils/DebugLogger';

interface DataTableInstance {
  loadData: () => void;
}

const resultadoFinanceiroTableRef = ref<DataTableInstance | null>(null);

const loadData = async () => {
  if (resultadoFinanceiroTableRef.value) {
    await resultadoFinanceiroTableRef.value.loadData();
  }
};

onMounted(() => log('ResultadoFinanceiroPage', 'mounted', 'Component mounted'));
onBeforeUnmount(() => log('ResultadoFinanceiroPage', 'beforeUnmount', 'Cleaning up'));

defineExpose({ loadData });
</script>
